<template>
  <div class="dashboard">
    <aside class="sidebar">
      <img src="@/assets/GR-logo.250.png" alt="Giverise Logo" class="logo" /> <!-- Replace text with image -->
      <ul class="nav-menu">
        <li @click="navigateTo('Dashboard')" class="nav-item active">Dashboard</li>
        <li @click="navigateTo('Tables')" class="nav-item">Tables</li>
        <li @click="navigateTo('Invitees')" class="nav-item">Invitees</li>
        <li @click="navigateTo('Donations')" class="nav-item">Donations</li>
        <li @click="logout" class="nav-item logout">Logout</li>
      </ul>
    </aside>
    
    <main class="main-content">
      <h1 class="main-title">Gala Dinner</h1>
      
    <!-- Search and Add Table Section -->
      <div class="search-and-add">
        <div class="search-container">
          <img src="@/assets/search.svg" alt="Search Icon" class="search-icon" />
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Search by name or table number"
            class="search-box"
          />
        </div>
        <button class="add-table-btn" @click="addTable">Add Table</button>
      </div>


      <div class="tables">
        <div v-for="table in filteredTables" :key="table.id" class="table-section">
          <div class="table-header">
            <h2 class="table-title">Table {{ table.number }}</h2>
            <button @click="removeTable(table.id)" class="table-remove">Remove Table</button>
          </div>
          
          <div class="invitee-list">
            <div class="invitee-row invitee-header">
              <span>Name</span>
              <span>Status</span>
              <span>Amount Donated</span>
            </div>
            <div
              v-for="invitee in table.invitees"
              :key="invitee.id"
              class="invitee-row"
              @click="openPopup(invitee)"
            >
              <span>{{ invitee.firstName }} {{ invitee.lastName }}</span>
              <span>{{ invitee.status }}</span>
              <span :class="{'highlighted': invitee.donated > 0}">${{ invitee.donated }}</span>
            </div>
          </div>
          <button @click="addInvitee(table.id)" class="add-invitee">Add Invitee</button>
        </div>
      </div>

      <!-- Popup for Invitee Details -->
      <InviteePopup
        v-if="selectedInvitee"
        :invitee="selectedInvitee"
        :isVisible="isPopupVisible"
        @update="updateInvitee"
        @close="closePopup"
      />
    </main>
  </div>
</template>

<script>
import InviteePopup from "./InviteePopup.vue";

export default {
  components: { InviteePopup },
  data() {
    return {
      eventTitle: "Gala Dinner",
      searchQuery: "",
      tables: [
        { id: 1, number: 1, invitees: [] },
        { id: 2, number: 2, invitees: [] },
      ],
      selectedInvitee: null,
      isPopupVisible: false,
    };
  },
  computed: {
    filteredTables() {
      return this.tables.filter((table) => {
        const matchesTableNumber = table.number
          .toString()
          .includes(this.searchQuery);
        const matchesInvitee = table.invitees.some(
          (invitee) =>
            invitee.firstName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            invitee.lastName.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
        return matchesTableNumber || matchesInvitee;
      });
    },
  },
  methods: {
    navigateTo(page) {
      this.$router.push({ name: page });
    },
    logout() {
      this.$router.push({ name: "Login" }); // Navigate to login screen on logout
    },
    addTable() {
      const newTable = {
        id: Date.now(),
        number: this.tables.length + 1,
        invitees: [],
      };
      this.tables.push(newTable);
    },
    removeTable(id) {
      this.tables = this.tables.filter((table) => table.id !== id);
    },
    addInvitee(tableId) {
      const table = this.tables.find((table) => table.id === tableId);
      table.invitees.push({
        id: Date.now(),
        firstName: "New",
        lastName: "Invitee",
        status: "Pending",
        donated: 0,
      });
    },
    openPopup(invitee) {
      this.selectedInvitee = { ...invitee };
      this.isPopupVisible = true;
    },
    updateInvitee(updatedInvitee) {
      const table = this.tables.find((table) =>
        table.invitees.some((inv) => inv.id === updatedInvitee.id)
      );
      if (table) {
        const index = table.invitees.findIndex((inv) => inv.id === updatedInvitee.id);
        if (index !== -1) {
          table.invitees.splice(index, 1, updatedInvitee);
        }
      }
      this.closePopup();
    },
    closePopup() {
      this.isPopupVisible = false;
      this.selectedInvitee = null;
    },
  },
};
</script>

<style scoped>
.dashboard {
  display: flex;
  /*background-color: #001643;*/
  color: white;
  height: 100vh;
}

.action-buttons {
  margin-bottom: 1rem;
}

.btn {
  background-color: #00cfff;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
}


.search-container {
  position: relative;
  display: inline-block;
  margin-bottom: 1rem;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px; /* Adjust icon size */
  height: 16px;
}

.search-box {
  padding: 0.5rem 1rem 0.5rem 2.5rem; /* Adjust padding to make space for icon */
  border-radius: 20px; /* Rounded corners */
  border: 1px solid #00cfff;
  width: 250px; /* Make the search box smaller */
  font-size: 1rem;
  color: #001643;
  outline: none;
}

.tables {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.table-section {
  background-color: #002855;
  padding: 1rem;
  border-radius: 8px;
  color: white;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-title {
  font-size: 1.3rem;
  color: #00cfff;
}

.table-remove {
  background: none;
  border: none;
  color: #ff3535;
  cursor: pointer;
}

.invitee-list {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}

.invitee-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #003366;
  cursor: pointer;
}

.invitee-header {
  font-weight: bold;
}

.highlighted {
  color: #00cfff;
}

.add-invitee {
  margin-top: 1rem;
  background-color: #00cfff;
  color: white;
  padding: 0.3rem 0.5rem;
  border: none;
  cursor: pointer;
}

.search-and-add {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.search-container {
  position: relative;
  display: inline-block;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}

.search-box {
  padding: 0.5rem 1rem 0.5rem 2.5rem;
  border-radius: 20px;
  border: 1px solid #00cfff;
  width: 250px;
  font-size: 1rem;
  color: #001643;
  outline: none;
}

.add-table-btn {
  background-color: #00cfff;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
}

</style>
